// Session storage helpers. We deliberately use sessionStorage (not
// localStorage) so tokens are scoped to the tab and cleared on close.

import type { TokenPair } from "../api/types";
import { appendTokensToHash } from "./returnTo";

const ACCESS = "cerberus_access";
const REFRESH = "cerberus_refresh";
const USER_ID = "cerberus_user_id";

export function persistTokens(tp: TokenPair): void {
  sessionStorage.setItem(ACCESS, tp.access_token);
  sessionStorage.setItem(REFRESH, tp.refresh_token);
  sessionStorage.setItem(USER_ID, tp.user_id);
}

export function readAccessToken(): string | null {
  return sessionStorage.getItem(ACCESS);
}

export function clearSession(): void {
  sessionStorage.removeItem(ACCESS);
  sessionStorage.removeItem(REFRESH);
  sessionStorage.removeItem(USER_ID);
}

export function completeLogin(tp: TokenPair, returnTo: string | null): void {
  persistTokens(tp);
  if (returnTo) {
    const dest = appendTokensToHash(
      returnTo,
      tp.access_token,
      tp.refresh_token,
      tp.user_id,
    );
    window.location.assign(dest);
  }
}
